import { useContext, useState } from "react";
import { useCallback } from "react";
import { HimmaContext } from "../Context/HimmaContext";
import { UpdateOrderStatusRequest } from "../client-sdk";

export const useOrderStatusUpdateApi = () => {
  const api = useContext(HimmaContext)!;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  /**
   * Update order or item(s) status
   * @param requestData - Request data object with orderId, orderNumber, acceptedItemIds, deniedItemIds, or itemIds
   */
  const updateOrderStatus = useCallback(
    async (
      requestData: {
        orderId: string;
        orderNumber: string;
        acceptedItemIds?: string[];
        deniedItemIds?: string[];
        itemIds?: string[];
        status: string;
        userId: string;
        userType: string;
        reason: string;
      }
    ) => {
      setLoading(true);
      setError(null);
      try {
        const updateRequest: UpdateOrderStatusRequest = {
          orderId: requestData.orderId,
          orderNumber: requestData.orderNumber,
          status: requestData.status as any,
          userId: requestData.userId,
          userType: requestData.userType as any,
          ...(requestData.itemIds ? { itemIds: requestData.itemIds } : {}),
          ...(requestData.acceptedItemIds ? { acceptedItemIds: requestData.acceptedItemIds } : {}),
          ...(requestData.deniedItemIds ? { deniedItemIds: requestData.deniedItemIds } : {}),
          reason: requestData.reason,
        };
        
        const response = await api.updateOrderStatus(updateRequest);
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : "An error occurred");
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );

  return {
    updateOrderStatus,
    loading,
    error,
  };
}; 